var _defs, _path, _rect, _rect2, _rect3, _path2, _g, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPromoMappe = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.4 168.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #6e9530;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.4,168.9l-71.6-20.4-70.1,20-70.1-20L0,168.9V20.4L71.6,0l70.1,20L211.8,0l71.6,20.4v148.5ZM71.6,145.4l70.1,20,70.1-20,68.6,19.6V22.7L211.8,3.1l-70.1,20L71.6,3.1,3,22.7v142.3l68.6-19.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 70.1,
    y: 13.9,
    width: 3,
    height: 120.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 210.3,
    y: 13.9,
    width: 3,
    height: 120.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 140.2,
    y: 33.9,
    width: 3,
    height: 120.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,73v-34.5l49.7-14.9v34.5l-49.7,14.9ZM15,40.7v28.3l43.7-13.1v-28.3l-43.7,13.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.7,103.4l-23.6-8v-42.1l23.6,8v42.1ZM109.1,93.2l17.6,6v-35.8l-17.6-6v35.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "100.1 64.4 83.5 58 83.5 29.6 123.3 41.5 123.3 52.2 120.3 52.2 120.3 43.7 86.5 33.6 86.5 55.9 101.2 61.6 100.1 64.4"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 83.1,
    y: 77.3,
    width: 3,
    height: 55.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 89.1,
    y: 74.3,
    width: 3,
    height: 55.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 95.1,
    y: 81.3,
    width: 3,
    height: 55.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.5,70.7v-24.6l37.2-10.9v24.6l-37.2,10.9ZM163.5,48.4v18.3l31.2-9.1v-18.3l-31.2,9.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.5,101.4v-24.6l37.2-10.9v24.6l-37.2,10.9ZM163.5,79v18.3l31.2-9.1v-18.3l-31.2,9.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.5,132v-24.6l37.2-10.9v24.6l-37.2,10.9ZM163.5,109.7v18.3l31.2-9.1v-18.3l-31.2,9.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.8,139.1l-21.9-5.8v-55.2l21.9,5.8v55.2ZM253.9,131l15.9,4.2v-49l-15.9-4.2v49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.6,76.5l-48.8-14.9V23.7l48.8,14.9v37.9ZM223.8,59.4l42.8,13.1v-31.6l-42.8-13.1v31.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.6,119.1l-23.8-8v-29l23.8,8v29ZM223.8,108.9l17.8,6v-22.6l-17.8-6v22.6Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPromoMappe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/promo-mappe.293b9158a111e0771e3470ed976949c4.svg";